import React from 'react';
import NavBar from './NavBar';
import Menu from './Menu';

const Home = (props) => {

    return (
        <>
            <div className="dommus-load-page" id="dommus-load-page">
                <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <NavBar client={props.client}/>
            <div className="dommus-wrapper">
                <Menu menu={props.menu} html={props.html}/>
            </div>
        </>
    )
};

export default Home;